import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PiV2OppCollapseComponent } from './pi-v2-opp-collapse/pi-v2-opp-collapse.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProjectV2 } from '@app/interfaces';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mnf-section-opportunities',
  standalone: true,
  imports: [PiV2OppCollapseComponent, MatExpansionModule, CommonModule],
  templateUrl: './section-opportunities.component.html',
  styleUrls: ['./section-opportunities.component.scss']
})
export class SectionOpportunitiesComponent implements OnChanges {

  @Input() infoProject: ProjectV2;

  defaultSection = false;
   
  sectionsProject = [
    { id: 0, title: 'Oportunidad de inversión', open: false, visible: true },
    // { id: 1, title: 'Esquema de financiamiento', open: false, visible: true },
    { id: 2, title: 'Rendimientos', open: false, visible: true },
    // { id: 3, title: 'Resumen financiero', open: false, visible: true },
    { id: 4, title: 'Simulador', open: false, visible: true },
    { id: 5, title: 'Documentos de la campaña', open: false, visible: true },
    { id: 6, title: 'Actualizaciones', open: false, visible: true },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.infoProject) {
      this.updateSectionVisibility();
    }
  }

  private updateSectionVisibility(): void {
    if (this.infoProject && this.infoProject.newProject) {
      if(this.infoProject?.actualState == 'fixed') {
        this.sectionsProject = this.sectionsProject.map(section => {
          if (section.id === 2) {
            section.visible = false;
          }
          return section;
        });
      } else if (this.infoProject?.actualState == 'variable') {
        this.sectionsProject = this.sectionsProject.map(section => {
          if (section.id === 4) {
            section.visible = false;
          }
          if (section.id === 2) {
            section.visible = !!this.infoProject?.newProject?.sectionOpInvest?.descriptionPerformance;
          }
          return section;
        });
      }
      this.sectionsProject = this.sectionsProject.map(section => {
        if (section.id === 5) {
          section.visible = !!this.infoProject.newProject.sectionOpInvest.documentsStep &&this.infoProject.newProject.sectionOpInvest.documentsStep.length >= 1;
        }
        return section;
      });
    }
  }
}
